export const WORK_PLAN = '/work-plan/' as const
export const WORK_PLAN_ASSIGNED_ALL = `${WORK_PLAN}assigned/all` as const
export const WORK_PLAN_CREATED_ALL = `${WORK_PLAN}created/all` as const
export const WORK_PLAN_UPDATE = `${WORK_PLAN}update` as const
export const WORK_PLAN_UPDATE_STATUS = `${WORK_PLAN_UPDATE}/status` as const
export const WORK_PLAN_STAFF_LIST = `${WORK_PLAN}staff-list` as const
// export const WORK_PLAN_USERS = `${WORK_PLAN}users` as const
